<template>
  <div class="w-full mx-auto">
    <div
      class="mt-4 relative flex items-center justify-center min-h-[250px] rounded-xl overflow-hidden bg-cover bg-center"
      :style="{ backgroundImage: 'url(' + require('@/assets/img/bkgPerfil.jpg') + ')', backgroundPositionY: '50%' }">
      <span class="absolute inset-0 bg-green-600/60 mix-blend-multiply"></span>
    </div>
    <div class="mx-4 overflow-hidden bg-white shadow-xl rounded-2xl p-4 -mt-16 relative z-10 border border-slate-100">
      <div class="flex flex-wrap items-center -mx-4">
        <div class="w-auto px-4">
          <div class="relative w-20 h-20 sm:w-24 sm:h-24">
            <img :src="acreditado && acreditado.foto ? acreditado.foto : require('@/assets/img/nologo.png')"
              class="shadow-md w-full h-full object-cover rounded-xl" />
          </div>
        </div>
        <div class="w-auto px-4 my-auto">
          <div class="h-full flex flex-col justify-center">

            <h5 class="text-xl font-bold mb-1 text-slate-800">{{ acreditado ? acreditado.nombre + " " +
              acreditado.apellido : $t('label.cargando') }}</h5>
            <p class="mb-0 text-xs text-slate-500">{{ $t('label.fecha.alta') }} : {{ acreditado ?
              formatDate(acreditado.fechaAlta, 'dd/MM/yyyy HH:mm:ss') : $t('label.cargando') }}</p>

            <span>
              <a @click="subirFotoPerfil"
                class="text-xs text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer">
                <font-awesome-icon :icon="['fas', 'fa-user-edit']" />
                {{ $t('boton.subir.foto') }}
              </a>
            </span>

          </div>
        </div>
        <div class="mx-auto mt-4 px-4 w-full md:w-1/2 lg:w-1/3 sm:my-auto sm:ml-auto sm:mr-0">
          <div class="relative w-full text-right">

            <button @click="mostrarCambiarPassword"
              class="px-3 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
              <font-awesome-icon :icon="['fas', 'fa-key']" class="mr-2" />{{ $t('boton.cambiar.password') }}
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="py-4 w-full mx-auto px-4">
    <div class="mt-3 flex flex-wrap -mx-4">

      <!-- Datos personales -->
      <div class="px-4 mb-6" :class="[usarPerfilEmpresas ? 'w-full lg:w-1/2' : 'w-full']">
        <div class="bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100">
          <div class="p-4 pb-0">
            <h6 class="text-lg font-bold text-slate-800 mb-0">Datos personales</h6>
          </div>
          <div class="p-4 grid grid-cols-3 gap-2 text-xs md:text-sm">
            <span class="text-slate-500 ">{{ $t('label.dni') }}</span>
            <span class="text-dark-gradient col-span-2">{{ acreditado ? acreditado.dni : $t('label.cargando') }}</span>
            <span class="text-slate-500 ">{{ $t('label.nombre') }}</span>
            <span class="text-dark-gradient col-span-2">{{ acreditado ? acreditado.nombre : $t('label.cargando')
            }}</span>
            <span class="text-slate-500 ">{{ $t('label.apellido') }}</span>
            <span class="text-dark-gradient col-span-2">{{ acreditado ? acreditado.apellido : $t('label.cargando')
            }}</span>
            <span class="text-slate-500 ">{{ $t('label.cargo') }}</span>
            <span class="text-dark-gradient col-span-2">{{ acreditado ? acreditado.cargo : $t('label.cargando')
            }}</span>
            <span class="text-slate-500">{{ $t('label.mail') }}</span>
            <span class="text-dark-gradient col-span-2">{{ acreditado ? acreditado.mail : $t('label.cargando') }}</span>
            <span class="text-slate-500">{{ $t('label.telefono') }}</span>
            <span class="text-dark-gradient col-span-2">{{ acreditado ? acreditado.telefono : $t('label.cargando')
            }}</span>
            <div class="col-span-3">
              <a @click="mostrarEdicionAcreditado"
                class="text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3">
                <font-awesome-icon :icon="['fas', 'fa-user-edit']" />
                {{ $t('boton.modificar') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Datos personales -->

      <!-- Datos de la empresa-->
      <div class="w-full lg:w-1/2 px-4 mb-6" v-if="usarPerfilEmpresas">
        <div class="bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100">

          <!-- Logo y nombre de fantasía -->
          <div class="flex flex-wrap items-center -mx-4 p-4 pb-0">
            <div class="w-auto px-4">
              <div class="relative w-20 h-20 sm:w-24 sm:h-24">
                <img :src="(empresa?.previewLogo) ? empresa.previewLogo : require('@/assets/img/nologo.png')"
                  class="shadow-md w-full h-full object-cover rounded-xl" />
              </div>
            </div>
            <div class="w-auto my-auto">
              <div class="h-full flex flex-col justify-center">
                <h5 class="text-xl font-bold mb-1 text-slate-800">{{ empresa ? empresa.nombreFantasia :
                  $t('label.cargando') }}</h5>
                <span v-if="empresa">
                  <a @click="subirLogoEmpresa"
                    class="text-xs text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer">
                    <font-awesome-icon :icon="['fas', 'fa-user-edit']" />
                    {{ $t('boton.subir.logo') }}
                  </a>
                </span>

              </div>
            </div>
          </div>
          <!-- Logo y nombre de fantasía -->

          <div class="p-4 grid grid-cols-3 gap-2 text-xs md:text-sm">
            <span class="text-slate-500 ">{{ $t('label.razon.social') }}</span>
            <span class="text-dark-gradient col-span-2">{{ empresa ? empresa.razonSocial : $t('label.cargando')
            }}</span>
            <span class="text-slate-500 ">{{ $t('label.cuit') }}</span>
            <span class="text-dark-gradient col-span-2">{{ empresa ? empresa.cuit : $t('label.cargando') }}</span>
            <span class="text-slate-500 ">{{ $t('label.pais') }}</span>
            <span class="text-dark-gradient col-span-2">{{ empresa ? (empresa?.pais?.descripcion ?? "") :
              $t('label.cargando') }}</span>
            <span class="text-slate-500">{{ $t('label.pabellon') }}</span>
            <span class="text-dark-gradient col-span-2">{{ empresa ? (empresa?.pabellon ?? "") : $t('label.cargando')
            }}</span>
            <span class="text-slate-500 ">{{ $t('label.numero.stand') }}</span>
            <span class="text-dark-gradient col-span-2">{{ empresa ? (empresa?.stand ?? "") : $t('label.cargando')
            }}</span>
            <div class="col-span-3">
              <a @click="mostrarEdicionEmpresa"
                class="text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3">
                <font-awesome-icon :icon="['fas', (empresa && empresa.id) ? 'fa-user-edit' : 'fa-plus']" />
                {{ (empresa && empresa.id) ? $t('boton.modificar') : $t('boton.crear.mi.empresa') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Datos de la empresa-->


      <!-- Resumen del acreditado -->
      <div v-if="cargarResumenAcreditado" class="w-full px-4 mb-6 mt-0">
        <div class="bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100">
          <div class="p-4 pb-0">
            <h6 class="text-lg font-bold text-slate-800 mb-0">{{ $t('label.resumen.acreditado') }}</h6>
          </div>
          <div class="p-4 flex flex-col">
            <div class="text-xs md:text-sm [&>p]:mb-2 [&>p:empty]:h-2"
              v-html="acreditado ? (resumenAcreditado ? resumenAcreditado : $t('label.no.cargo.resumen.acreditado')) : $t('label.cargando')">
            </div>
            <div class="w-full">
              <a @click="mostrarEdicionResumenAcreditado"
                class="text-sm text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3">
                <font-awesome-icon :icon="['fas', 'fa-user-edit']" />
                {{ $t('boton.modificar') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Resumen del acreditado -->

      <!-- Resumen Empresa -->
      <div class="w-full px-4 mb-6 mt-0" v-if="usarPerfilEmpresas">
        <div class="bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100">
          <div class="p-4 pb-0">
            <h6 class="text-lg font-bold text-slate-800 mb-0">{{ $t('label.resumen.empresa') }}</h6>
          </div>
          <div class="p-4 flex flex-col">
            <div class="text-xs md:text-sm [&>p]:mb-2 [&>p:empty]:h-2"
              v-html="empresa ? (empresa.breveDescripcion ? empresa.breveDescripcion : $t('label.no.cargo.empresa')) : $t('label.cargando')">
            </div>
            <div class="w-full">
              <a @click="mostrarEdicionResumenEmpresa"
                class="text-sm text-gray-400 inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer my-3">
                <font-awesome-icon :icon="['fas', 'fa-user-edit']" />
                {{ $t('boton.modificar') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Resumen Empresa -->

      <!-- Detalle de acreditados de la empresa -->
      <div class="w-full px-4 mb-6 mt-0" v-if="usarPerfilEmpresas">
        <div class="bg-white shadow-lg rounded-2xl flex flex-col h-full border border-slate-100">
          <div class="p-4 pb-0">
            <h6 class="text-lg font-bold text-slate-800 mb-1">{{ $t('label.acreditados.empresa') }}</h6>
          </div>
          <div class="p-4 flex flex-col">

            <ul class="divide-y divide-gray-200 list-none pb-4">
              <li v-for="(item, i) in acreditadosEmpresa" :key="i">
                <div class="flex items-center gap-3 py-2 mx-3">
                  <div class="h-16 w-16 rounded-lg shadow-xl flex items-center justify-center border">
                    <font-awesome-icon :icon="['fas', 'fa-user']" class="text-2xl"
                      :class="item.administradorEmpresa ? 'text-green-700' : 'text-gray-500'" />
                  </div>

                  <div class="flex-1 text-left">
                    <div class="text-sm font-semibold text-gray-700 uppercase">{{ item.nombre }}</div>
                    <div class="text-sm font-semibold text-gray-700 uppercase">{{ item.apellido }}</div>
                    <div class="text-xs">{{ item.mail }}</div>
                  </div>

                  <div class="relative">
                    <a v-if="esAdministrador() && !item.administradorEmpresa"
                      @click="preguntaCambiarAdministrador(item)"><font-awesome-icon :icon="['fas', 'fa-user-tie']"
                        class="text-2xl mr-2 text-gray-500 hover:text-green-700 cursor-pointer" /></a>
                    <a v-if="!item.administradorEmpresa" @click="preguntaDesasociarUsuario(item)"><font-awesome-icon
                        :icon="['far', 'fa-trash-can']"
                        class="text-2xl mr-2 text-gray-500 hover:text-red-600 cursor-pointer" /></a>
                  </div>
                </div>
              </li>
            </ul>

            <div class="w-full">
              <button @click="invitarUsuarioEmpresa"
                class="px-5 text-sm font-bold text-white py-3 bg-gradient-to-r from-[#424c42] to-[#bbc1a9] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                <font-awesome-icon :icon="['far', 'fa-paper-plane']" class="mr-2" />{{ $t('boton.invitar.usuario') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Detalle de acreditados de la empresa -->

    </div>
  </div>

  <FullScreenLoader :visible="isSubmitting" />

  <EditarAcreditadoView v-if="editarAcreditadoVisible" :closeFunction="closeDialogAcreditado" />
  <EditarEmpresaView v-if="editarEmpresaVisible" :closeFunction="closeDialogEmpresa" />
  <EditarResumenEmpresaView v-if="editarResumenEmpresaVisible" :closeFunction="closeDialogResumenEmpresa" />
  <EditarResumenAcreditadoView v-if="editarResumenAcreditadoVisible" :closeFunction="closeDialogResumenAcreditado" />
  <CambiarPasswordView v-if="cambiarPasswordVisible" :closeFunction="closeDialogCambiarPassword" />
  <EnviarInvitacionView v-if="enviarInvitacionVisible" :empresa="empresa"
    :closeFunction="closeDialogEnviarInvitacion" />

  <ModalFileUpload :visible="isFileUploadVisible" :askDescription="false" :forceSquare="false" :maxSizeMB="2"
    :fileTypes="['image/png', 'image/jpg', 'image/jpeg']" :onAccept="onFileUploadAcepted"
    @update:visible="isFileUploadVisible = $event" />
  <ModalFileUpload :visible="isLogoFileUploadVisible" :askDescription="false" :forceSquare="false" :maxSizeMB="2"
    :fileTypes="['image/png', 'image/jpg', 'image/jpeg']" :onAccept="onLogoFileUploadAcepted"
    @update:visible="isLogoFileUploadVisible = $event" />

  <CropperView v-if="showCropper" :image="beforeCropBase64" @close="onCropFinished" />
  <CropperView v-if="logoShowCropper" :image="logoBeforeCropBase64" @close="onLogoCropFinished" />

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import ModalFileUpload from "@/components/commons/ModalFileUpload.vue";
import CropperView from "@/components/commons/CropperView.vue";
import FullScreenLoader from '@/components/commons/FullScreenLoader.vue';

import suiteService, { Acreditado } from "qreventos-suite/services";
import { formatDate } from '@/utils/formatters';

import EditarAcreditadoView from '@/components/views/private/modal/EditarAcreditadoView.vue';
import CambiarPasswordView from '@/components/views/private/modal/CambiarPasswordView.vue';
import EditarEmpresaView from '@/components/views/private/modal/EditarEmpresaView.vue';
import EditarResumenEmpresaView from '@/components/views/private/modal/EditarResumenEmpresaView.vue';
import EditarResumenAcreditadoView from '@/components/views/private/modal/EditarResumenAcreditadoView.vue';
import EnviarInvitacionView from './modal/EnviarInvitacionView.vue';

import { ArchivoAcreditado, Empresa, TipoArchivo } from "qreventos-suite/src/services/suite.interfaces";
import { TIPO_ARCHIVO_FOTO } from "qreventos-suite/constantes";

import seguridadServices from "@/services/seguridad.services";
import meetingService, { ConfiguracionMeeting } from 'qreventos-suite/meeting';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import archivoAcreditadoService from "qreventos-suite/archivo.acreditado";
import empresaService from 'qreventos-suite/empresas';

export default defineComponent({
  components: {
    EditarAcreditadoView, EditarEmpresaView, EditarResumenEmpresaView, CambiarPasswordView, EnviarInvitacionView, EditarResumenAcreditadoView,
    ModalFileUpload, CropperView,
    FullScreenLoader,
  },
  data() {
    return {
      acreditado: undefined as unknown as Acreditado,
      empresa: undefined as unknown as Empresa,
      isSubmitting: false,
      editarAcreditadoVisible: false,
      editarEmpresaVisible: false,
      editarResumenEmpresaVisible: false,
      editarResumenAcreditadoVisible: false,
      enviarInvitacionVisible: false,
      cambiarPasswordVisible: false,

      cargarResumenAcreditado: false,
      resumenAcreditado: '',

      // Foto de perfil y logo de empresa
      isFileUploadVisible: false,
      fotoFileName: '',
      beforeCropBase64: '',
      showCropper: false,

      usarPerfilEmpresas: false,

      isLogoFileUploadVisible: false,
      logoFileName: '',
      logoBeforeCropBase64: '',
      logoShowCropper: false,

      acreditadosEmpresa: [] as Acreditado[],
    };
  },
  methods: {
    formatDate,

    /**
     * Gestión de datos de acreditado
     */
    mostrarEdicionAcreditado() {
      this.editarAcreditadoVisible = true;
    },
    closeDialogAcreditado(reload: boolean = false) {
      this.editarAcreditadoVisible = false;
      if (reload) {
        this.acreditado = undefined as unknown as Acreditado;
        this.fillAcreditado();
      }
    },
    /**
     * Gestión de datos de empresa
     */
    mostrarEdicionEmpresa() {
      if (!this.acreditado.administradorEmpresa && this.empresa != null && this.empresa != undefined && this.empresa.id != undefined) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.administrador.cambia.empresa'), icon: "info" });
        return;
      }

      this.editarEmpresaVisible = true;
    },
    closeDialogEmpresa(reload: boolean = false) {
      this.editarEmpresaVisible = false;
      if (reload) {
        this.fillAcreditado();
        this.empresa = undefined as unknown as Empresa;
        this.fillEmpresa();
      }
    },
    /**
     * Gestión de resumen de empresa
     */
    mostrarEdicionResumenEmpresa() {
      if (!this.empresa || !this.empresa.id) {
        Swal.fire({
          title: this.$t('global.atencion'),
          html: this.$t('label.sin.empresa.creada'),
          icon: "info",
          confirmButtonText: this.$t('boton.aceptar')
        }).then((result) => {
          if (result.isConfirmed || result.value) {
            this.mostrarEdicionEmpresa();
          }
        });
        return;
      } else {
        this.editarResumenEmpresaVisible = true;
      }
    },
    closeDialogResumenEmpresa(reload: boolean = false) {
      this.editarResumenEmpresaVisible = false;
      if (reload) {
        this.empresa = undefined as unknown as Empresa;
        this.fillEmpresa();
      }
    },
    /**
     * Gestión de resúmen de acreditado
     */
    mostrarEdicionResumenAcreditado() {
      this.editarResumenAcreditadoVisible = true;
    },
    closeDialogResumenAcreditado(reload: boolean = false) {
      this.editarResumenAcreditadoVisible = false;
      if (reload) {
        this.fillAcreditado();
      }
    },
    /**
     * Recarga de datos generales
     */
    async fillAcreditado() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      this.usarPerfilEmpresas = configuracionMeeting.usarPerfilEmpresas;

      this.acreditado = await meetingService.findAcreditadoMeetingBy(configuracionMeeting.evento.id, hash);

      if (configuracionMeeting.campoResumenAcreditado) {
        this.cargarResumenAcreditado = true;

        const campo = configuracionMeeting.campoResumenAcreditado.campoAcreditado as keyof typeof this.acreditado;
        this.resumenAcreditado = this.acreditado[campo];
      }
    },
    async fillEmpresa() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      if (configuracionMeeting.usarPerfilEmpresas) {
        if (this.acreditado) {
          this.empresa = await meetingService.findEmpresaAcreditadoBy(configuracionMeeting.evento.id, hash);

          if (this.empresa) {
            this.acreditadosEmpresa = await suiteService.findAcreditadosByEmpresa(configuracionMeeting.evento.id, this.empresa.id);
          } else {
            this.empresa = {} as Empresa;
          }
        }
      }
    },
    /**
     * Gestión de cambio de clave
     */
    mostrarCambiarPassword() {
      this.cambiarPasswordVisible = true;
    },
    closeDialogCambiarPassword(cambioOk: boolean = false) {
      this.cambiarPasswordVisible = false;
      if (cambioOk) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.cambio.clave.exitosa'), icon: "success" }).then(() => {
          this.logout();
        });
      }
    },
    /**
     * Gestión de usuarios asociados
     */
    esAdministrador() {
      if (this.acreditadosEmpresa) {
        const admin: Acreditado = this.acreditadosEmpresa?.find(a => a.administradorEmpresa) as Acreditado;
        if (admin && admin.id == this.acreditado.id) {
          return true;
        }
      }
      return false;
    },
    invitarUsuarioEmpresa() {
      if (!this.empresa || !this.empresa.id) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.cargar.empresa.primero'), icon: "info" });
        return;
      }

      if (!this.acreditado.administradorEmpresa) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.usuario.admin.puede.invitar'), icon: "info" });
        return;
      }
      this.enviarInvitacionVisible = true;
    },
    closeDialogEnviarInvitacion(enviada: boolean = false) {
      this.enviarInvitacionVisible = false;
      if (enviada) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.invitacion.enviada'), icon: "success" });
      }
    },
    preguntaCambiarAdministrador(acreditado: Acreditado) {
      Swal.fire({
        title: this.$t('global.atencion'),
        html: this.$t('label.pregunta.cambiar.administrador'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('boton.si.cambiar'),
        cancelButtonText: this.$t('boton.cancelar'),
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {
          this.cambiarAdministrador(acreditado);
        }
      });
    },
    async cambiarAdministrador(acreditado: Acreditado) {
      try {
        this.isSubmitting = true;

        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        const ok: boolean = await empresaService.cambiarAdministrador(configuracionMeeting.evento.id, this.empresa.id, acreditado.id);
        if (ok) {
          await this.fillAcreditado();
          await this.fillEmpresa();
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    preguntaDesasociarUsuario(acreditado: Acreditado) {
      Swal.fire({
        title: this.$t('global.atencion'),
        html: this.$t('label.pregunta.desasociar.usuario'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('boton.si.desasociar'),
        cancelButtonText: this.$t('boton.cancelar'),
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {
          this.desasociarUsuario(acreditado);
        }
      });
    },
    async desasociarUsuario(acreditado: Acreditado) {
      try {
        this.isSubmitting = true;

        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        const ok: boolean = await empresaService.desasociarAcreditadoEmpresa(configuracionMeeting.evento.id, this.empresa.id, acreditado.id);
        if (ok) {
          await this.fillAcreditado();
          await this.fillEmpresa();
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    /**
     * Logout
     */
    logout() {
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      seguridadServices.logout();
      this.$router.push({ path: '/' + configuracionMeeting.contextUrl });
      configuracionMeetingService.remove();
    },
    /**
     * Gesión de logo de empresa
     */
    subirLogoEmpresa() {
      if (!this.empresa || !this.empresa.id) {
        Swal.fire({
          title: this.$t('global.atencion'),
          html: this.$t('label.sin.empresa.creada'),
          icon: "info",
          confirmButtonText: this.$t('boton.aceptar')
        }).then((result) => {
          if (result.isConfirmed || result.value) {
            this.mostrarEdicionEmpresa();
          }
        });
        return;
      }
      this.isLogoFileUploadVisible = true;
    },
    onLogoFileUploadAcepted(base64: string, fileName: string) {
      const base64Splited: string = base64.split(',')[1];

      this.logoFileName = new Date().getTime() + "_" + fileName.replace(/[^a-zA-Z0-9.]/g, '');
      this.logoBeforeCropBase64 = base64;
      this.logoShowCropper = true;
    },
    async onLogoCropFinished(croppedB64: string) {
      this.logoShowCropper = false
      if (!croppedB64) {
        return
      }

      const base64Splited = croppedB64.split(',')[1]

      try {
        this.isSubmitting = true;

        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        this.empresa.logoBase64 = base64Splited;
        this.empresa.logoFileName = this.logoFileName;
        const ok: boolean = await empresaService.updateLogo(configuracionMeeting.evento.id, this.empresa);
        if (ok) {
          this.acreditado.foto = undefined as unknown as string;
          this.fillAcreditado();
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    /**
     * Gestión de imagen de perfil
     */
    subirFotoPerfil() {
      this.isFileUploadVisible = true;
    },
    async onFileUploadAcepted(base64: string, fileName: string) {
      const base64Splited: string = base64.split(',')[1];

      this.fotoFileName = new Date().getTime() + "_" + fileName.replace(/[^a-zA-Z0-9.]/g, '');
      this.beforeCropBase64 = base64;
      this.showCropper = true;
    },
    async onCropFinished(croppedB64: string) {
      this.showCropper = false
      if (!croppedB64) {
        return
      }

      const base64Splited = croppedB64.split(',')[1]

      try {
        this.isSubmitting = true;

        const fotoPerfilAcreditado: ArchivoAcreditado = {} as ArchivoAcreditado;
        fotoPerfilAcreditado.tipoArchivo = { "id": TIPO_ARCHIVO_FOTO } as TipoArchivo;
        fotoPerfilAcreditado.descripcion = "FOTO PERFIL MEETING";
        fotoPerfilAcreditado.fileName = this.fotoFileName;
        fotoPerfilAcreditado.fileDataBase64 = base64Splited;

        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        const ok: boolean = await archivoAcreditadoService.saveOrReplace(configuracionMeeting.evento.id, this.acreditado.id, fotoPerfilAcreditado);
        if (ok) {
          this.acreditado.foto = undefined as unknown as string;
          this.fillAcreditado();
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  async mounted() {
    try {
      this.isSubmitting = true;

      await this.fillAcreditado();
      await this.fillEmpresa();

    } catch (error) {
      this.isSubmitting = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>
